import React, { Component } from 'react';
import './Spin.css';  // Import your CSS for the loader

// function Loader() {
 
// }

export class  Spinner extends Component{
    render(){
        return (
          <div class="center-body">
          <div class="loader-square-8">
            <div class="cube1"></div>
            <div class="cube2"></div>
            <div class="cube3"></div>
            <div class="cube4"></div>
            <div class="cube5"></div>
            <div class="cube6"></div>
            <div class="cube7"></div>
            <div class="cube8"></div>
            <div class="cube9"></div>
           </div>
          </div>
          );

    }
  

}
